interface BuildModeToggleProps {
  buildMode: boolean;
  onToggle: () => void;
}

/** Build mode toggle — owner/admin only, enters furniture editing for this room.
    Label intentionally untranslated, matching the sibling GodModeToggle: an
    owner/admin-only technical control, not player-facing content. */
export default function BuildModeToggle({ buildMode, onToggle }: BuildModeToggleProps) {
  return (
    <div
      data-tutorial="build-toggle"
      onClick={onToggle}
      style={{
        position: 'absolute',
        top: 16,
        right: 16,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        padding: '6px 24px',
        borderRadius: '50px',
        background: 'rgba(219, 219, 219, 0.3)',
        boxShadow: 'inset 4px 3px 5.9px 0px rgba(0, 0, 0, 0.12)',
        cursor: 'pointer',
        pointerEvents: 'auto',
      }}
    >
      <img
        src="/ui/icons/build-mode-icon.png"
        alt="Build mode"
        style={{
          width: '28px',
          height: '28px',
          objectFit: 'contain',
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'relative',
          width: '39px',
          height: '24px',
          borderRadius: '100px',
          background: buildMode ? '#6750A4' : 'rgba(219, 219, 219, 0.5)',
          padding: '1.5px 3px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: buildMode ? 'flex-end' : 'flex-start',
          transition: 'all 0.2s ease',
        }}
      >
        <div
          style={{
            width: '21px',
            height: '21px',
            borderRadius: '24px',
            background: '#FFFFFF',
            boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
            transition: 'all 0.2s ease',
          }}
        />
      </div>
    </div>
  );
}
